import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface IBladeState {
    data: Array<IBlade> | null;
    notes?: string;
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    showLoading: ILoading;
    isLoading: boolean;
    isSuccess: boolean;
    details: IBlade | null;
    physRacks: Array<IRackInt> | null;
    bladeLogonHistory: Array<IBladeLogonHistory> | null;
}

// Define the initial state using that type
const initialState: IBladeState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null,
    physRacks: null,
    bladeLogonHistory: null,
};

export const bladeSlice = createSlice({
    name: 'blade',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceBlade: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        replaceRack: (state, action) => {
            const { data } = action.payload;
            state.physRacks = data;
        },
        addBlade: (state, action) => {
            const newItem = action.payload.data;
            if (state.data && state.data.length > state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount = state.totalCount + 1;
        },
        updateBlade: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
                state.data[localID] = data;
            }
            state.details = data;
        },
        deleteBlade: (state, action) => {
            const bladeToRemove: IBlade = action.payload.data;
            const newBladeData = state.data && state.data.filter(
                (blade: IBlade) => {
                    return (
                        blade.id !== bladeToRemove.id
                    );
                }
            );
            state.data = newBladeData;
            state.totalCount = state.totalCount - 1;
        },
        setBladeDetails: (state, action) => {
            state.details = action.payload.data;
        },
        setBladeLogonHistory: (state, action) => {
            state.bladeLogonHistory = action.payload.data;
        }
    },
});

export const bladeActions = bladeSlice.actions;

export default bladeSlice.reducer;
